import { IInteractionMetricsDistributions } from "@edgetier/watchtower-types";

/**
 * Get the start and end value for metric distributions.
 * @param data Metric distrinutions data.
 * @returns An object with a startValue and endValue.
 */
export const getMetricDistributionStartAndEndValue = (data: IInteractionMetricsDistributions | undefined) => {
    if (typeof data === "undefined" || data.length === 0) {
        return { startValue: 0, endValue: 0 };
    }

    const first = data[0];
    const last = data[data.length - 1];
    if ("minimumValue" in first && "maximumValue" in last) {
        return { startValue: first.minimumValue, endValue: last.maximumValue };
    }

    if ("value" in first && "value" in last) {
        return { startValue: first.value ? 1 : 0, endValue: last.value ? 1 : 0 };
    }

    return { startValue: 0, endValue: 0 };
};
